
























































import { Component, Vue } from "vue-property-decorator";
import CourseForm from "@/components/courses/CourseForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import {
  CourseCreate as ICourseCreate,
  Course as ICourse,
  CourseInfoEdit as ICourseInfoEdit
} from "@/api-v2/course/models";
import CourseFormV2 from "@/components/courses/CourseV2/CourseFormV2.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { courseApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CourseInfoForm from "@/components/courses/CourseV2/CourseInfoForm.vue";
import { CourseDocumentInfoEdit as ICourseDocumentInfoEdit } from "@/api-v2/course-document-info/models";
import CourseDocumentFrom from "@/components/courses/CourseV2/CourseDocumentFrom.vue";

@Component({
  components: {
    CourseDocumentFrom,
    CourseInfoForm,
    CPageButtons,
    CourseFormV2,
    CField,
    CBlock,
    CPage,
    CBreadCrumbs,
    CourseForm
  }
})
export default class CourseEditV2 extends Vue {
  course!: ICourse;
  form!: ICourseCreate;
  isLoading: boolean = false;
  isNewCourseInfo: boolean = false;
  documentForm!: ICourseInfoEdit;
  courseDocumentForm: ICourseDocumentInfoEdit = {};

  data() {
    return {
      documentForm: undefined,
      form: undefined,
      course: undefined
    };
  }

  courseDocumentInfoEdit() {
    return courseApi.CourseDocumentInfo.editCourseDocumentInfo(
      this.$route.params.id,
      this.courseDocumentForm
    );
  }

  courseMainEdit() {
    return courseApi.Course.editCourse(this.$route.params.id, this.form);
  }

  async courseEdit() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;

    this.isLoading = true;

    try {
      const requests = await Promise.allSettled([
        this.courseMainEdit(),
        this.courseInfoEdit(),
        this.courseDocumentInfoEdit()
      ]);
      if (requests?.every(el => el.status === "fulfilled")) {
        await this.$router.push({
          name: "course",
          params: { id: this.$route.params.id }
        });
      } else {
        const rejected = requests.filter(el => el.status === "rejected");
        rejected?.forEach((el: any) => {
          this.$store.dispatch(
            "localError",
            el?.reason?.response.data.violations.detail ??
              `${this.$tc(this.$translate.UnknownError)}`
          );
        });
      }
    } finally {
      this.isLoading = false;
    }
  }

  courseInfoEdit() {
    return courseApi.CourseInfo.editCourseInfo(this.$route.params.id, {
      price: this.$converter.setPrice(this.documentForm.price ?? 0),
      hours: this.documentForm.hours
    });
  }

  courseRemove() {
    this.isLoading = true;
    courseApi.Course.deleteCourse(this.course.id)
      .then(() => {
        this.$router.push({ name: "courses" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  decline() {
    this.$router.push({ name: "courses" });
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$tc(this.$translate.Courses)
      },
      {
        to: { name: "course", params: { id: this.course.id } },
        label: this.course.title
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async getDocumentInfo() {
    await courseApi.CourseDocumentInfo.getCourseDocumentInfo(
      this.$route.params.id
    )
      .then(res => {
        this.courseDocumentForm.validityOfDocument =
          res.data.validityOfDocument ??
          this.courseDocumentForm.validityOfDocument;

        this.courseDocumentForm.documentTypeId =
          res.data?.documentType?.id ?? this.courseDocumentForm.documentTypeId;

        this.courseDocumentForm.qualification =
          res.data?.qualification ?? this.courseDocumentForm.qualification;

        this.courseDocumentForm.specialtyId =
          res.data?.specialty?.id ?? this.courseDocumentForm.specialtyId;

        this.courseDocumentForm.programId =
          res.data?.program?.id ?? this.courseDocumentForm.programId;

        this.courseDocumentForm.activityId =
          res.data?.activity?.id ?? this.courseDocumentForm.activityId;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getDocumentInfo();
    courseApi.Course.getCourse(this.$route.params.id)
      .then(res => {
        this.course = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });

    courseApi.CourseInfo.getCourseInfo(this.$route.params.id)
      .then(res => {
        this.documentForm = res.data;
        if (res.data.price) {
          this.documentForm.price = this.$converter.getPrice(res.data.price);
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        if (err.response && err.response.status === 404) {
          this.isNewCourseInfo = true;
          this.documentForm = {
            hours: 0,
            price: 0
          };
        } else {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        }
      });
  }
}
